import Serializable from "Serializable";

class RiPanelTransactionsSettings extends Serializable {

    constructor() {
        super();
        this.isTransactionsVisible = false;
        this.tranOpacity = 1
        this.isRoundtripShadingVisible = true;
        this.selectedPortfolios = [];
    }

    OnSeralisedInfoRecieved(serializedValue) {
        this.isTransactionsVisible = serializedValue.isTransactionsVisible ? serializedValue.isTransactionsVisible : false;
        this.tranOpacity = serializedValue.tranOpacity ? serializedValue.tranOpacity : 1;
        this.isRoundtripShadingVisible = serializedValue.isRoundtripShadingVisible ? serializedValue.isRoundtripShadingVisible : true;
        this.selectedPortfolios = serializedValue.selectedPortfolios ? serializedValue.selectedPortfolios : [];
    }

    getObjectMapKey() {
        return "RiPanelTransactionsSettings";
    }

    getDataObject() {
        return {
            isTransactionsVisible: this.isTransactionsVisible,
            tranOpacity: this.tranOpacity,
            isRoundtripShadingVisible: this.isRoundtripShadingVisible,
            selectedPortfolios: this.selectedPortfolios
        };
    }
}

export default RiPanelTransactionsSettings;